/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useMemo } from "react";

import { MediaType } from "../../../../../../shared/types/enums";
import { usePlayerCurrentMedia } from "../../../../../Controller";

import "./Metadata.scss";

export const Metadata = () => {
  const { media } = usePlayerCurrentMedia();

  const title = media.Title;

  const subtitle = useMemo(() => {
    if (
      media?.OrderInParent &&
      media.MediaTypeCode !== MediaType.Live &&
      media.MediaTypeCode !== MediaType.Video
    ) {
      if (media?.ParentOrderInParent) {
        return `S${media.ParentOrderInParent}E${media.OrderInParent}`;
      }

      return `E${media.OrderInParent}`;
    }

    return undefined;
  }, [media.MediaTypeCode, media.OrderInParent, media.ParentOrderInParent]);

  return (
    <div className="Metadata">
      {title && <p>{title}</p>}
      {subtitle && <span>{subtitle}</span>}
    </div>
  );
};
